import React, { useEffect, useContext, useState } from "react";
import { AuthContext } from '../../contexts/auth';
import { useParams } from 'wouter';

import BusteDetailAr from '../../components/areariservata/buste_detail_ar';

import { Popover } from '@headlessui/react';
import Footer from "../../components/footer";

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

export default function ArSingleCedolino() {
  console.log("ArSingleCedolino");

  const { token } = useContext(AuthContext);

  const { resourceId } = useParams();

  useEffect(() => {
      // setCurrentPage('/areariservata/cedolini')
  })

  return (
    <div className='flex flex-col min-h-screen'>
      <div className='flex-grow pb-8'>
        <Popover as="header" className={`bg-indigo-200`}>
          <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:max-w-7xl lg:px-8">
            <div className="relative flex flex-wrap items-center justify-center lg:justify-between">
              <div className="w-full -5 lg:border-t lg:border-white lg:border-opacity-20">
                <div className="flex justify-center my-2 py-2">
                  <h2 className="text-center text-2xl font-semibold text-indigo-800">
                    Dettagli Cedolino
                  </h2>
                </div>
              </div>
            </div>
          </div>
        </Popover>
        <BusteDetailAr loading={true} token={token} resourceId={resourceId}  />
      </div>
      <Footer />
    </div>
  )
}